import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';

export type IAuthToken = {
  readonly access: string;
  readonly refresh: string;
  readonly expires: string;
};

export type IAuthUser = {
  readonly id: number;
  readonly username: string;
  readonly email: string;
  readonly last_login: string;
  readonly must_reset_password: boolean;
};
export type IAuthSlice = {
  token: IAuthToken;
  user: IAuthUser;
  isLoggedIn: boolean;
};
const initialState: IAuthSlice = {
  token: {
    access: '',
    refresh: '',
    expires: ''
  },
  user: {
    id: 0,
    email: '',
    last_login: '',
    must_reset_password: false,
    username: ''
  },
  isLoggedIn: false
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    SET_AUTH_TOKEN: (
      state,
      action: PayloadAction<Omit<IAuthSlice, 'isLoggedIn'>>
    ) => ({
      ...state,
      token: action.payload.token,
      user: action.payload.user,
      isLoggedIn: !!action.payload.token.access
    }),
    RESET_AUTH_TOKEN: () => initialState
  }
});

export const { SET_AUTH_TOKEN, RESET_AUTH_TOKEN } = authSlice.actions;

export const GET_AUTH_CONFIG = (state: RootState) => state.app.auth;
